import { KindeContextProps } from '@kinde-oss/kinde-auth-react';
import { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { lazy } from 'react';

interface AuthRouterContext {
  auth: KindeContextProps;
  queryClient: QueryClient;
}

let TanStackRouterDevtools;
if (process.env.NODE_ENV === 'production') {
  TanStackRouterDevtools = () => null;
} else {
  TanStackRouterDevtools = lazy(() =>
    import('@tanstack/react-router-devtools').then((res) => ({
      default: res.TanStackRouterDevtools,
    }))
  );
}

export const Route = createRootRouteWithContext<AuthRouterContext>()({
  component: () => (
    <>
      <Outlet />
      <TanStackRouterDevtools />
    </>
  ),
});
